"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** Function component */
const react_1 = __importDefault(require("react"));
const Hello = (props) => {
    return (react_1.default.createElement("h1", null,
        "Hello ",
        props.name || 'Talisis'));
};
exports.default = Hello;
